module.exports = __webpack_public_path__ + "static/media/icon_excel.bac00f37.svg";